(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bubble-studio"] && !Shopify.designMode) return;
  try {
    
function initBubbleStudios() {
  document.querySelectorAll('.bubble-studio').forEach(function(studio) {
    if(studio.dataset.ready) return;
    studio.dataset.ready = 'true';
    studio.querySelectorAll('.studio-swatch').forEach(function(button) {
      button.addEventListener('click',function() {
        studio.querySelectorAll('.studio-swatch').forEach(function(item) { item.setAttribute('aria-pressed','false'); });
        button.setAttribute('aria-pressed','true');
        studio.querySelector('[data-colour-label]').textContent = button.dataset.colourName;
        studio.querySelector('.studio-selected-dot').style.backgroundColor = button.dataset.colourHex;
      });
    });
  });
}
function initStudioFilms() {
  document.querySelectorAll('.studio-hero-film').forEach(function(figure) {
    if(figure.dataset.ready)return;
    var video=figure.querySelector('video');
    if(!video)return;
    figure.dataset.ready='true';
    var motion=window.matchMedia?window.matchMedia('(prefers-reduced-motion: reduce)'):null;
    var connection=navigator.connection;
    var failed=false;
    var blocked=false;
    var disposed=false;
    var pending=false;
    var playbackVersion=0;
    var inView=false;
    video.muted=true;video.loop=true;video.playsInline=true;video.controls=false;
    video.disablePictureInPicture=true;video.disableRemotePlayback=true;
    video.removeAttribute('controls');video.removeAttribute('autoplay');video.tabIndex=-1;
    function shouldPlay(){return !disposed&&!failed&&!blocked&&inView&&!document.hidden&&!(motion&&motion.matches)&&!(connection&&connection.saveData);}
    function stop(showPoster){if(pending)playbackVersion++;if(!video.paused)video.pause();if(showPoster)video.hidden=true;}
    function syncPlayback(){
      if(!shouldPlay()){stop(true);return;}
      if(pending||!video.paused)return;
      pending=true;video.hidden=false;
      var result;
      var version=playbackVersion;
      try{result=video.play();}catch(error){pending=false;blocked=true;stop(true);return;}
      Promise.resolve(result).then(function(){pending=false;if(!shouldPlay())stop(true);else if(video.paused)syncPlayback();}).catch(function(){pending=false;if(version!==playbackVersion){syncPlayback();return;}blocked=true;stop(true);});
    }
    function mediaFailed(){failed=true;stop(true);}
    video.addEventListener('error',mediaFailed);
    var observer;
    if('IntersectionObserver' in window){
      observer=new IntersectionObserver(function(entries){entries.forEach(function(entry){inView=entry.isIntersecting&&entry.intersectionRatio>=.2;syncPlayback();});},{threshold:.2});
      observer.observe(figure);
    }else{inView=true;syncPlayback();}
    if(motion&&motion.addEventListener)motion.addEventListener('change',syncPlayback);
    if(connection&&connection.addEventListener)connection.addEventListener('change',syncPlayback);
    document.addEventListener('visibilitychange',syncPlayback);
    function cleanup(event){
      if(!event.target.contains(figure))return;
      disposed=true;stop(true);
      if(observer)observer.disconnect();
      if(motion&&motion.removeEventListener)motion.removeEventListener('change',syncPlayback);
      if(connection&&connection.removeEventListener)connection.removeEventListener('change',syncPlayback);
      video.removeEventListener('error',mediaFailed);
      document.removeEventListener('visibilitychange',syncPlayback);
      document.removeEventListener('shopify:section:unload',cleanup);
    }
    document.addEventListener('shopify:section:unload',cleanup);
  });
}
initBubbleStudios();
initStudioFilms();
document.addEventListener('shopify:section:load',initBubbleStudios);
document.addEventListener('shopify:section:load',initStudioFilms);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tc-header"] && !Shopify.designMode) return;
  try {
    
function initialiseAnnouncements(root) {
  root.querySelectorAll('[data-tc-announcement]').forEach(bar => {
    if (bar.dataset.ready) return;
    bar.dataset.ready = 'true';
    const track = bar.querySelector('.tc-announcement-track');
    const group = bar.querySelector('.tc-announcement-group');
    const measure = () => track.style.setProperty('--tc-announcement-duration', (group.getBoundingClientRect().width / 38) + 's');
    measure();
    new ResizeObserver(measure).observe(group);
    document.fonts.ready.then(measure);
  });
}
initialiseAnnouncements(document);
document.addEventListener('shopify:section:load', event => initialiseAnnouncements(event.target));

  } catch(e) { console.error(e); }
})();
})();
